<template>
	<div style="display: contents">

		<v-slide-y-transition>
			<v-card-text class="pb-0 pt-2 px-0" v-if="showFilters">
				<v-container fluid class="pa-0">
					<v-subheader class="pl-4">Filtri Avanzati</v-subheader>
					<v-row class="ma-0">
						<v-col cols="12" sm="6" md="4" lg="3" class="py-0" :class="{'pr-4': $vuetify.breakpoint.smAndUp}">
							<v-autocomplete
								:items="existingFilters"
								v-model="existingFilterSelected"
								label="Seleziona un filtro esistente"
								item-text="title"
								item-value="id"
								:menu-props="{maxHeight:'200', nudgeBottom: 3}"
								return-object
								no-data-text="Nessun filtro esistente"
								@change="changeSelectedFilter"
								outlined
								dense>
								<template v-slot:item="data">
									<template>
										<v-list-item-avatar
											size="34px"
											style="min-width: 34px; width: 34px; height:34px; border-radius: 50%"
											class="primary mr-4">
											<span style="color: white !important" class="margin-auto">{{ data.item.creator ? data.item.creator.slice(0, 1).toUpperCase() : '' }}</span>
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title>{{ data.item.title }}</v-list-item-title>
											<v-list-item-subtitle>
												<span>{{ data.item.subtitle }}&nbsp;
												</span>
											</v-list-item-subtitle>
										</v-list-item-content>
									</template>
								</template>							
							
							</v-autocomplete>
						</v-col>
						<v-col cols="12" sm="6" md="4" lg="3" class="py-0" :class="{'pr-4': $vuetify.breakpoint.mdAndUp}">
							<v-text-field
								label="Nome del Filtro"
								v-model="filterName"
								required
								:error-messages="errors.collect('Nome del Filtro')"
								v-validate="'required'"
								:data-vv-name="'Nome del Filtro'"
								outlined
								dense 
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="4" lg="3"  offset-lg="3" class="pr-6 py-0">
							<v-switch
								inset
								class="text-center col-1 text-no-wrap flex ma-0 px-0 py-2"
								label="Visibile a tutti"
								v-model="visibleToAll"
								color="primary"
								hide-details
							></v-switch>
						</v-col>
					</v-row>
					<v-row class="ma-0">
			          	<v-col cols="12" sm="12" md="8" lg="8" class="py-0 pb-5" :class="{'pr-4': $vuetify.breakpoint.mdAndUp}">
				          	<v-autocomplete
					          	label="Filtri"
					          	:items="availableFilters"
					          	v-model="availableFilterSelected"
					          	multiple
					          	small-chips
					          	clearable
					          	return-object
					          	item-text="label"
					          	item-value="key"
								outlined
								dense
								hide-details
						   	></v-autocomplete>
		   	          	</v-col>
					</v-row>
					<v-row class="ma-0">
		   	          	<v-col lg="3" md="3" cols="12" class="pr-6 py-0">
		   	          		<v-switch
								class="text-center col-1 text-no-wrap flex ma-0 px-0 py-2"
								inset
		   	          			label="Verifica tutte le condizioni"
		   	          			v-model="model['and_or']"
		   	          			color="primary"
								hide-details
		   	          		></v-switch>
		   	          	</v-col>
						<v-col lg="3" md="3" cols="12" class="pr-6 py-0">
		   	          		<v-switch
								class="text-center col-1 text-no-wrap flex ma-0 px-0 py-2"
								inset
		   	          			label="Diverso"
		   	          			v-model="model['not']"
		   	          			color="primary"
								hide-details
		   	          		></v-switch>
		   	          	</v-col>
					</v-row>

					<v-subheader v-if="availableFilterSelected.length > 0" class="pl-4">Filtri Selezionati</v-subheader>

					<v-row class="ma-0">
						<template v-for="(input, i) in availableFilterSelected">

							<template v-if="input.type == 'date'">
								<v-col :class="defaultClass(input)" :key="'from_'+i" class="py-2">
									<gmh-date-picker
										:value="model[input.key].from"
										@input="(val) => setDate(input.key, 'from', val)"
										:label="input.label + ' - Dal'"
										editable
										hide-details
										field-class="pr-4"
									></gmh-date-picker>
								</v-col>
								<v-col :class="defaultClass(input)" :key="'to_'+i" class="py-2">
									<gmh-date-picker
										:value="model[input.key].to"
										@input="(val) => setDate(input.key, 'to', val)"
										:label="input.label + ' - Al'"
										editable
										hide-details
										field-class="pr-4"
									></gmh-date-picker>
								</v-col>
							</template>

							<template v-else-if="input.type == 'number'">
								<v-col class="pr-4 py-2" :class="defaultClass(input)" :key="'from_n_' + i">
									<v-text-field
										:type="input.type"
										:label="input.label + ' - Da'"
										v-model="model[input.key].from"
										outlined
										dense
										hide-details
									></v-text-field>
								</v-col>
								<v-col class="pr-4 py-2" :class="defaultClass(input)" :key="'to_n_' + i">
									<v-text-field
										:type="input.type"
										:label="input.label + ' - A'"
										v-model="model[input.key].to"
										outlined
										dense
										hide-details
									></v-text-field>
								</v-col>
							</template>

							<v-col v-else-if="input.type == 'boolean' || input.type == 'null'" class="py-2" :class="defaultClass(input)" :key="i">
								<v-switch
								  inset
								  class="text-center col-1 text-no-wrap flex ma-0 px-0 py-2"
                                  :label="input.label"
                                  v-model="model[input.key]"
								  color="primary"
								  hide-details
                            	></v-switch>
                            </v-col>

							<v-col v-else-if="['belongsTo', 'generalTypes', 'morphTo', 'belongsToMany', 'belongsToThrough', 'chips'].includes(input.type)" class="py-2" :class="defaultClass(input)" :key="i">
								<v-autocomplete
									:items="input.options"
									:label="input.label"
									v-model="model[input.key]"
									autocomplete
									clearable
									:multiple="input.multiple"
									:small-chips="input.multiple"
									hide-details
									outlined
									dense
									:return-object="!!input.async"
									:search-input.sync="search[input.key]"
									:cache-items="!!input.async"
									:filter="(item, queryText, itemText) => $eventBusUtility.customFilter(item, queryText, itemText, input.searchKeys)">
									
									<template v-slot:selection="data">
										<v-chip
											v-bind="data.attrs"
											:input-value="data.selected"
											:close="input.close"
											:multiple="input.multiple"
											small
											pill
											@click="data.select"
											@click:close="removeChip(data.item, input)">
											<v-avatar v-if="data.item.avatar" left>
												<v-img :src="data.item.avatar"></v-img>
											</v-avatar>
											<v-avatar v-else-if="getIcon(data.item)"
												small
												pill
												style="min-width: 24px !important; width: 24px !important; height: 24px !important; border-radius: 50%"
												class="primary mr-4 v-avatar--left">
												<v-icon class="fs16i" color="white">{{ getIcon(data.item) }}</v-icon>
											</v-avatar>				
											<v-avatar v-else-if="input.chips"
												left
												style="height: 24px !important; width: 24px !important"
												class="primary white--text">
												{{ getInitialAvatar(data, input)}}
											</v-avatar>
											<div class="xs3 string-cutter" :style="{'max-width': getWidth(input.key)}">{{ input.item_text ? data.item[input.item_text] : data.item.text }}</div>
										</v-chip>
									</template>

									<template v-slot:item="data">
										<template v-if="typeof data.item !== 'object'">
											<v-list-item-content v-text="data.item"></v-list-item-content>
										</template>
										<template v-else>
										<v-list-item-avatar v-if="getIcon(data.item)"
											size="32px"
											style="min-width: 32px; width: 32px; height:32px; border-radius: 50%"
											class="primary mr-4">
											<v-icon class="fs18i" color="white">{{ getIcon(data.item) }}</v-icon>
										</v-list-item-avatar>
										<v-list-item-avatar v-else-if="data.item.avatar" style="margin-right: 10px;">
											<v-avatar
												class="custom-avatar"
												:size="34" 
												:style="{'background-image': 'url(' + data.item.avatar + ')'}">
											</v-avatar>
										</v-list-item-avatar>
										<v-list-item-avatar v-else-if="input.chips"
											size="34px"
											style="min-width: 34px; width: 34px; height:34px; border-radius: 50%"
											class="primary mr-4">
											<span style="color: white !important" class="margin-auto">{{ getInitialAvatar(data, input)}}</span>
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title>{{ input.item_text ? data.item[input.item_text] : data.item.text }}</v-list-item-title>
											<v-list-item-subtitle>
												<span v-for="(key, k) in input.searchKeys" :key="k" :class="getTextClass(key)">{{$trans(data.item[key])}}&nbsp;
												</span>
											</v-list-item-subtitle>
										</v-list-item-content>
									</template>
									</template>

									<template v-slot:no-data>
										<v-list-item>
											<v-list-item-content>
												<v-list-item-title v-if="search[input.key]">
													Nessun risultato per "<strong>{{ search[input.key] }}</strong>".
												</v-list-item-title>
												<v-list-item-title v-else-if="input.async">
													Cerca...
												</v-list-item-title>
												<v-list-item-title v-else>
													Nessun risultato
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</template>
								</v-autocomplete>
							</v-col>

							<v-col v-else :class="defaultClass(input)" class="py-2" :key="i">
								<v-text-field
									:type="input.type ? input.type : 'text'"
									:label="input.label"
									v-model="model[input.key]"
									color="primary"
									outlined
									dense
									hide-details
								></v-text-field>
							</v-col>
						</template>
					</v-row>
				</v-container>
				
				<v-card-actions v-if="$vuetify.breakpoint.xs" class="pt-0 px-4">
					<v-spacer></v-spacer>
					<v-btn v-if="showDelete" text icon @click="deleteFilter()">
						<v-icon color="error">delete</v-icon>
					</v-btn>
					<v-btn text icon @click="saveFilter('new')">
						<v-icon color="primary">add</v-icon>
					</v-btn>
					<v-btn text icon @click="empties()">
						<v-icon color="red">close</v-icon>
					</v-btn>
					<v-btn v-if="editAndSave" text icon @click="saveFilter('update')">
						<v-icon color="primary">edit</v-icon>
					</v-btn>
				</v-card-actions>
				<v-card-actions v-else class="pt-0 px-4">
					<v-spacer></v-spacer>
					<v-btn v-if="showDelete" text color="error" @click="deleteFilter()">Elimina</v-btn>
					<v-btn text color="primary" @click="saveFilter('new')">Salva come nuovo</v-btn>
					<v-btn text color="red" @click="empties()">Svuota</v-btn>
					<v-btn v-if="editAndSave" text color="primary" @click="saveFilter('update')">Modifica e Salva</v-btn>
				</v-card-actions>

			</v-card-text>
		</v-slide-y-transition>
		<v-divider v-show="showFilters"></v-divider>
	</div>
</template>
<script>

import Vue from 'vue'
import InputMixin from '@/mixins/InputMixin'

export default {
	name: 'advanced-filters',
	mixins: [InputMixin],
	props: {
		infoAvailableFilters: Array,
		modelDef: String,
		filtered: Boolean,
		showFilters: Boolean,
		crudSearch: String,
		getCache: {
			default: true,
			type: Boolean
		},
		filterSelected: Object,
	},

	data() {
		return {
			existingFilters: [],
			existingFilterSelected: [],
			availableFilters: this.infoAvailableFilters,
			availableFilterSelected: [],
			model: {
                and_or: true,
                not: false,
			},
			visibleToAll: false,
			filterName: null,
			presaveFilters: [],
			showDelete: false,
			editAndSave: false,
			fireEvent: false,
			debounce: false,
			search: {},
			asyncDebounce: null
		}
	},

	computed: {
		getWidth() {
			return (key) => {
				if(this.$refs[key]) {
					return this.$refs[key][0] ? this.$refs[key][0].$el.clientWidth - (this.$refs[key][0].$el.clientWidth * 30 / 100) + 'px' : ''
				}
			} 
		},
	},

	watch: {

		existingFilterSelected: {
			handler(val) {
				this.$emit('update:filterSelected', val)
				localStorage.setItem('advanced_filter_'+this.modelDef, JSON.stringify(this.existingFilterSelected))
				if(val.id){
					this.showDelete = this.editAndSave = true
				}
				else
					this.showDelete = false
			}
		},

		availableFilterSelected: {
			handler(val, oldVal) {

				if(_.isEmpty(val)) {
					this.$emit('update:filtered', false)
				} else {
					this.$emit('update:filtered', true)
				}

				let keys = {}

				_.forEach(this.availableFilterSelected, (value) => {
					keys[value.key] = value.type
				})

				_.forEach(this.model, (value, key) => {
					if(key != 'and_or' && key != 'not' && typeof keys[key] === 'undefined'){
						if(Array.isArray(this.model[key])) {
							Vue.set(this.model, key, [])
						} else if(typeof this.model[key] === 'object'){
							Vue.set(this.model, key, {})
						} 
						else {
							Vue.set(this.model, key, '')
						}
					} else if(keys[key] === 'boolean'){
						if(typeof this.model[key] !== 'boolean') {
							Vue.set(this.model, key, false)
						}
					}
				})

				localStorage.setItem('availableFilterSelected_'+this.modelDef, JSON.stringify(keys))
			}
		},

		model: {
			handler(oldVal, newVal) {
				if(this.fireEvent) {
					if(this.debounce)
						clearTimeout(this.debounce)

					this.debounce = setTimeout(() => {
						this.$eventBusUtility.$emit('filters_'+this.modelDef, this.model)
					}, 300)
				}
				this.fireEvent = true
			},
			deep: true
		},

		search: {
			handler(oldVal, newVal) {
				_.forEach(this.search, (s, k) => {
					let field = _.filter(this.availableFilterSelected, (field) => {
						return field.key == k
					})
					if(field.length > 0) {
						this.$eventBusUtility.asyncSearch(field[0] , s)
					}
				})
			},
			deep: true
		},

		'model.not': {
			handler(val) {
				if (val === this.model.and_or) {
					this.fireEvent = false
					Vue.set(this.model, 'and_or', !val)
				}
			}
		},
		// 'model.and_or': {
		// 	handler(val) {
		// 		if (val === this.model.not) {
		// 			this.fireEvent = false
		// 			Vue.set(this.model, 'not', !val)
		// 		}
		// 	}
		// }
	},

	methods: {

		setDate(key, sub_key, val) {
			Vue.set(this.model[key], sub_key, val)
		},

		defaultClass(input) {
			if(typeof input.class === 'undefined')
				return 'col-md-3 col-lg-3 pr-4'
			else 
				return input.class
		},

		deleteFilter() {
			this.axios.post('filters/delete',{id: this.existingFilterSelected.id}).then(response => {
				// get body data
				this.existingFilters = response.data.data.options
				this.presaveFilters = response.data.data.filters

				this.$store.commit('setSnackbar', {timeout: 6000, text: 'Filtro eliminato con successo', value: true, color: 'success'})

				this.empties()
			}, response => {
				// error callback
			})
		},

		empties() {
			this.availableFilterSelected = []
			this.existingFilterSelected = {}
			this.filterName = null
			this.visibleToAll = false
			this.editAndSave = false
			this.model = {}
			this.setModel()
			delete localStorage['advanced_filter_'+this.modelDef]
			delete localStorage['availableFilterSelected_'+this.modelDef]
			delete localStorage['crud_advancedFilters_'+this.modelDef]
		},

		changeSelectedFilter(event) {
			this.filterName = event.title
			this.availableFilterSelected = []

			let currentFilter = _.filter(this.presaveFilters, (f) => {
				return f.id === event.id
			})

			if (!currentFilter.length) return

			this.visibleToAll = currentFilter[0].visible_to_all === 1 ? true : false
			Vue.set(this.model, 'and_or', currentFilter[0].and_or === 1 ? true : false)
			Vue.nextTick(() => {
				_.forEach(currentFilter[0].value, (value, key) => {
					Vue.set(this.model, key, value)

					_.forEach(this.availableFilters, (object, k) => {
						if(object.key === key) {
							this.availableFilterSelected.push(object)
							if(_.isArray(value)) {
								if(typeof object.async !== 'undefined' && object.async){
									let value_key = object.item_value ? object.item_value : 'value'
									let text_key = object.item_text ? object.item_text : 'text'
									let options = []
									_.forEach(value, (val, i) => {
										options.push(val)
									})

									Vue.set(this.availableFilters[k], 'options', options)
								}
							}
						}
					})
				})
			}) 
		},
			
		initialize() {
			this.axios.get('filters/'+this.modelDef).then(response => {
				// get body data
				this.existingFilters = response.data.data.options
				this.presaveFilters = response.data.data.filters
				if(this.getCache){
					if(localStorage.getItem('advanced_filter_'+this.modelDef) !== null && localStorage.getItem('advanced_filter_'+this.modelDef) != '{}'){
						this.existingFilterSelected = JSON.parse(localStorage.getItem('advanced_filter_'+this.modelDef))
						if(! _.isEmpty(this.existingFilterSelected)){
							this.changeSelectedFilter(this.existingFilterSelected)
						}
					} else {
						if(localStorage.getItem('availableFilterSelected_'+this.modelDef) !== null) {
							_.mapKeys(JSON.parse(localStorage.getItem('availableFilterSelected_'+this.modelDef)), (value, key) => {
								_.forEach(this.availableFilters, (val, k) => {
									if(val['key'] == key ) {
										this.availableFilterSelected.push(val)
									}
								}) 
							})
						}

						if(localStorage.getItem('crud_advancedFilters_'+this.modelDef) !== null) {
							Object.assign(this.model, JSON.parse(localStorage.getItem('crud_advancedFilters_'+this.modelDef)))

							_.forEach(this.availableFilters, (field, k) => {
								if(typeof field.async !== 'undefined' && field.async){
									let options = []
									_.forEach(this.model[field.key], (val, i) => {
										options.push(val)
									})

									Vue.set(this.availableFilters[k], 'options', options)
								}
							})
						}
						
					}
				}
			}, response => {
				// error callback
			})
		},

		setModel() {
			_.forEach(this.availableFilters, (value, k) => {
				if(value.structure === 'object') {
					Vue.set(this.model, value.key, {})
				} else if(value.structure === 'array') {
					Vue.set(this.model, value.key, [])
				} else {
					Vue.set(this.model, value.key, '')
				}
			})

			Vue.set(this.model, 'and_or', true)
			Vue.set(this.model, 'not', false)
		},

		saveFilter(type) {
			this.$validator.validateAll().then(result => {
				if (!result) {
					return false
				} else {

					let data = {
						'title': this.filterName,
						'value': this.model,
						'visible_to_all': this.visibleToAll,
						'and_or': this.model['and_or'],
						'model_class': this.modelDef
					}

					let url = 'filters/'
					let filterSnackbarText = 'Filtro creato con successo'

					// If in edit
					if(type === 'update') {
						url = url + this.existingFilterSelected.id
						data.id = this.existingFilterSelected.id
						filterSnackbarText = 'Filtro aggiornato con successo'
					}
					// If in store
					this.axios.post(url, data).then(response => {
						// get body data

						this.$store.commit('setSnackbar', {timeout: 6000, text: filterSnackbarText, value: true, color: 'success'})


						this.existingFilters = response.data.data.options
						this.presaveFilters = response.data.data.filters
						this.existingFilterSelected = response.data.data.stored_filter

					}, response => {
						// error callback
					})
				}
			})
		}
	},

	created() {

		this.setModel()
		this.initialize()
	},

	beforeDestroy() {
		if(this.debounce) {
			clearTimeout(this.debounce)
		}
	},
}

</script>